module.exports = "<select ng-model=\"value\">\n  <option ng-repeat=\"num in options\" value=\"{{num}}\">{{num}}</option>\n</select>\n"


//////////////////
// WEBPACK FOOTER
// ./public/dev/components/directive/dead_duration_selector/dead_duration_selector.html
// module id = 683
// module chunks = 0